import { keyframes } from "styled-components/macro";
// Animations
export const bgFade = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }`;

export const growHeight = keyframes`
    from {
        max-height: 0;
    }
    to {
        max-height: 9999px;
    }`;

export const toggleMainNav = keyframes`
    0% {
        transform: translateY(0);
        backface-visibility: hidden;
        zoom: 1;
    }
    100% {
        transform: translateY(-37px);
        backface-visibility: hidden;
        zoom: 0;
    }`;

export const appearFromCenter = keyframes`
    from {
        transform: scale(0);
    }
    to {
        transform: scale(1);
    }`;

export const pulse = keyframes`
    0% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }`;

export const pulseAndGrow = keyframes`
    0% {
        opacity: 0;
        transform: scale(0.4);
    }
    33% {
        opacity: 1;
        transform: scale(1);
    }
    66% {
        opacity: 0.6;
        transform: scale(1.4);
    }
    100% {
        opacity: 0.8;
        transform: scale(0.6);
    }`;

export const slideFromLeft = keyframes`
    from {
        transform: translateX(-100%);
    }
    to {
        transform: translateX(0);
    }`;

export const slideFromLeftFadeIn = keyframes`
    from {
        opacity: 0;
        transform: translateX(-100%);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }`;

export const ticker = keyframes`
    0% {
        transform: translateZ(0);
    }
    to {
        transform: translate3d(-208rem, 0, 0);
    }`;

export const slideDown = keyframes`
    0% { 
          opacity: 0; 
          -webkit-transform: translateY(-100%); 
    }   
    
    100% { 
        opacity: 1; 
        -webkit-transform: translateY(0); 
    }`;
